// src/components/common/Avatar/ProfileAvatar.jsx
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { LogOut, HelpCircle, Bell } from "lucide-react";
import logo from "../../../Images/logo.png";
import "../../../styles/ProfileAvatarnew.css";
import { fetchUserData } from "../../../services/authServicepa";

const StudentAvatar = ({ isOpen, onClose, notificationCount = 0 }) => {
  const [email, setEmail] = useState("");
  const [showSupportPopup, setShowSupportPopup] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const getUserData = async () => {
      try {
        const userData = await fetchUserData();
        if (userData) setEmail(userData.email_id || "");
      } catch (error) {
        console.error("Error fetching user data:", error);
      }
    };
    getUserData();
  }, []);

  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("role");
    localStorage.removeItem("emp_name");
    localStorage.removeItem("placementFilterState");
    localStorage.removeItem("placementDbFilters");
    localStorage.removeItem("placedStudentFilters");
    localStorage.removeItem("jobDashboardFilters");
    localStorage.removeItem("jobDashboard-selectedColumns");
    sessionStorage.removeItem("lastActiveTab");
    sessionStorage.removeItem("lastJobReqPath");
    setEmail("");
    navigate("/", { replace: true });
  };

  const handleNotificationsClick = () => {
    onClose?.();
    navigate("/student/notifications");
  };

  const settingsItems = [
    {
      label: "Support",
      icon: HelpCircle,
      action: () => {
        setShowSupportPopup(true);
        onClose?.();
      },
    },
    {
      label: "Logout",
      icon: LogOut,
      action: handleLogout,
    },
  ];

  return (
    <>
      <div className={`avatar-container ${isOpen ? "mobile-open" : ""}`}>
        <div className="avatar-profile-container">
          <div className="avatar-button">
            <img src={logo} alt="PUMO TECHNOVATION" className="logo-image" />
          </div>
          <div className="avatar-emp-name">PUMO TECHNOVATION</div>
        </div>

        <div className="avatar-dropdown">
          {/* <div className="nav-section">
            <div className="nav-section-title">Notifications</div>
            <button
              className="dropdown-item notification-item"
              onClick={handleNotificationsClick}
            >
              <Bell size={20} className="navsb-icon" />
              <span className="nav-label">Notifications</span>
              {notificationCount > 0 && (
                <span className="notification-badge">
                  {notificationCount > 99 ? "99+" : notificationCount}
                </span>
              )}
            </button>
          </div> */}

          <div className="nav-section">
            <div className="nav-section-title">Settings</div>
            {settingsItems.map((item, index) => {
              const IconComponent = item.icon;
              return (
                <button key={index} className="dropdown-item" onClick={item.action}>
                  <IconComponent size={20} className="navsb-icon" />
                  <span className="nav-label">{item.label}</span>
                </button>
              );
            })}
          </div>
        </div>
      </div>

      {showSupportPopup && (
        <div className="popup-overlay">
          <div className="popup-box">
            <h3>Support</h3>
            <p>
              If you have any queries related to this application, contact{" "}
              <strong>Mr.Hari - 9025680801</strong>
            </p>
            <p>
              For any escalations, contact <strong>Mr.Muthu – 9176655299</strong>
            </p>
            <button className="closes-btn" onClick={() => setShowSupportPopup(false)}>
              Close
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default StudentAvatar;